import { makeRestApiRequest } from '~src/httpClient/RestApiService';

import { IPackage } from '../../models/IPackage';
import { API_VERSION, PACKAGES_PATH } from '../constants/RestApiConstants';

// PUT by luid; server returns 409 PACKAGE_MANIFEST_MISMATCH if the uploaded manifest id differs.
export interface IUpdatePackageResponse {
  package?: IPackage;
}

export class UpdatePackageService {
  public static updatePackage(packageLuid: string, archive: File): Promise<IUpdatePackageResponse> {
    const formData = new FormData();
    formData.append('archive', archive);

    return makeRestApiRequest<FormData, IUpdatePackageResponse>({
      restApiVersion: API_VERSION,
      httpMethod: 'PUT',
      endpoint: `${PACKAGES_PATH}/${packageLuid}`,
      requestBody: formData,
      headers: { 'Accept': 'application/json' },
    });
  }
}
